import localeDateFilter from "@/filters/localedatefilter"
import { i18n } from "@/plugins/i18n"

function formatter() {
  function formatDays(numDays) {
    if (numDays !== undefined && numDays !== null) {
      if (numDays === 0) {
        return i18n.global.t("common.enums.day.today")
      }

      if (numDays === 1) {
        return i18n.global.t("common.enums.day.yesterday")
      }
      return i18n.global.t("common.units.daysAgo", numDays)
    }
    return ""
  }
  function formatDaysFromNow(date) {
    if (date !== undefined && date !== null) {
      const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
      const startDate = new Date(date)
      const endDate = new Date()

      const diffDays = Math.round(Math.abs((startDate - endDate) / oneDay))
      return this.formatDays(diffDays)
    }
    return ""
  }
  function formatLastSeen(machine) {
    if (machine.status === "running" || machine.status === "online") {
      return machine.status
    } else {
      return localeDateFilter(machine.lastSeen)
    }
  }
  function toHoursMinutesSeconds(timeInSeconds) {
    return new Date(timeInSeconds * 1000).toISOString().substr(11, 8)
  }
  function formatDate(date) {
    if (!(date instanceof Date)) {
      date = new Date(date)
    }

    return date.toISOString().substring(0, 10)
  }
  return {
    formatDays,
    formatDaysFromNow,
    formatLastSeen,
    toHoursMinutesSeconds,
    formatDate
  }
}
export default formatter
